import { LabelWrapper } from '@gameday/react-components/components'
import ListItem from '@gameday/react-components/components/ListItem'
import { remove } from 'lodash'
import styled from 'styled-components'

import commonStyles from '../../../styles/common-styles.module.scss'

const StyledListItemWrap = styled.div`
  .MuiListItem-root {
    .MuiCheckbox-colorPrimary.Mui-checked {
      color: var(--custom-primary-color) !important;
    }
  }
`

const StyledListItem = styled(ListItem)`
  height: 52px;
`

function Component({
  onChange = () => {},
  disabled,
  errorText,
  required,
  memberTypes = [],
  label,
  value,
  name,
  id,
  isToolTip,
  toolTipText,
  allowOnlyOneMemberType,
  heading = 'Member Type',
}) {
  return (
    <>
      <h3>{heading}</h3>
      <hr />
      <LabelWrapper
        name={name}
        label={label}
        isRequired={required}
        isToolTip={isToolTip}
        errorText={errorText}
        toolTipText={toolTipText}
      >
        <StyledListItemWrap>
          {memberTypes.map(type => {
            const selected = (value || []).find(v => v.sfid === type.sfid)
            return (
              <StyledListItem
                className={commonStyles.listItem}
                disabled={disabled}
                key={type.sfid}
                label={type.name}
                description={type.description}
                type={allowOnlyOneMemberType ? 'radio' : 'checkbox'}
                isChecked={!!selected}
                onSelected={() => {
                  if (allowOnlyOneMemberType) {
                    onChange([type])
                    return
                  }

                  const newSelected = [...value]
                  if (selected) {
                    remove(newSelected, v => v.sfid === type.sfid)
                  } else {
                    newSelected.push({ ...type })
                  }
                  onChange(newSelected)
                }}
                id={`${id}-option-${type.name}`}
                data-testid="memberTypeOption"
              />
            )
          })}
        </StyledListItemWrap>
      </LabelWrapper>
    </>
  )
}

export default Component
